<template>
    <!-- <div :style="pageStyling"> -->
<div>
    <transition
        enter-active-class="transition duration-400 ease-in"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition duration-400 ease-out"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        class="h-full"
    >
    </transition>
    <base-card>
        <EngagementFilters @change-engagement-filters="setEngagementFilters"></EngagementFilters>
        <div class="flex items-center mx-1">
          <div class="flex flex-wrap items-center space-x-2 mx-1.5">
            <div class="group flex justify-start items-center space-x-2">
              <h3 class="text-sm">Active Sorts:</h3>
            </div>
            <base-pill v-if="orderByInvoiceDay" class="bg-amber-300 flex items-center justify-between text-xs space-x-2 p-2 mb-0.5 ">
            <div> {{ orderFieldLabel(orderByInvoiceDay) }} </div><button @click="clearOrderingByInvoiceDay">✕</button> 
            </base-pill>
            <base-pill class="bg-amber-300 flex items-center justify-between text-xs space-x-2 p-2 mb-0.5 " v-for="ordering, idx in orderBy" :key="ordering">
            <div> {{ orderFieldLabel(ordering) }} </div><button @click="clearOrdering(idx)">✕</button> 
            </base-pill>
          </div>
        </div>
    </base-card>
    <base-card>
    <div class="flex flex-col text-sm text-gray-900 h-[85vh]">
        <div class="flex flex-col justify-start lg:flex-row w-full mb-2">
            <div class="px-3 h-full flex w-full lg:w-fit flex-row justify-start py-2 border-b border-light-primary lg:py-0 lg:border-none items-center align-middle text-center 0">
            </div>
            <div class="flex flex-row items-center justify-between py-2 border-b border-light-primary lg:py-0 lg:border-none w-full h-full px-2 ">
                <base-pagination-header
                class="w-full"
                @load-data="loadEngagements(fetchFilter)"
                @get-next="getNext"
                @go-to-first="goToFirst"
                @get-prev="getPrev"
                @go-to-last="goToLast"
                @jump-to-page="jumpToPage"
                @set-page-size-filter="setPageSizeFilter"
                :page_filter="pageSizeFilter"
                :page="page"
                :numPages="totalPages"
                :isLoading="isLoading"
                >
                <template v-slot:message>
                    <div class="pl-3 pt-1 whitespace-nowrap">
                    {{ viewingFromNbr }}-{{ viewingToNbr }} | {{ count }} Total Engagements | Total Retainers: {{ retainerAmount }}
                    </div>
                </template>
                </base-pagination-header>
                <div class="flex items-center space-x-2">
                  <base-button @click="draftInvoiceVisible = true">Create Invoice</base-button>
                  <base-button v-if="canDoAccounting" @click="openCreateForm">Create Engagement</base-button>
                </div>
                <base-modal :is-form-visible="formVisible" @close="closeCreateForm">
                    <template #header>
                        <h2 class="text-lg">
                          Create Engagement
                        </h2>
                    </template>
                    <template #body>
                        <EngagementForm
                            :clients="clients"
                            @submit-form="createNewEngagement"
                            @cancel="closeCreateForm"
                        />
                    </template>
                </base-modal>
                <InvoiceDraftModal
                    :is-visible="draftInvoiceVisible"
                    :engagements="engagements"
                    @close="draftInvoiceVisible = false"
                    @saved="onInvoiceSaved"
                />

            </div>
        </div>
        <div v-if="engagements.length > 0" class="h-full overflow-y-auto">
        <base-table>
            <template #table-header>
            <base-table-header class="text-center" :key="header.value" :header="header" v-for="header in tableHeadersList"> 
              <div class="flex  items-center justify-between space-x-1">
                <div>
                  {{ header.value }}
                </div>
                <div v-if="header.orderFieldName">
                  <div @click="changeOrdering(header.orderFieldName)" v-if="noOrdering(header.orderFieldName)" class="text-sm flex flex-col space-y-0" >
                    <div class=" hover:cursor-pointer">▲</div>
                    <div class=" hover:cursor-pointer">▼</div>
                  </div>
                  <div @click="changeOrdering(header.orderFieldName)" v-else-if="orderedAscending(header.orderFieldName)">
                    <div class=" hover:cursor-pointer">▲</div>
                  </div>
                  <div @click="changeOrdering(header.orderFieldName)" v-else-if="orderedDescending(header.orderFieldName)">
                    <div class=" hover:cursor-pointer">▼</div>
                  </div>
                </div>
                <div v-else-if="header.value == 'Days Until Next Calc. Invoice Day'">
                  <div @click="setOrderByInvoiceDay('desc')" v-if="!orderByInvoiceDay" class="text-sm flex flex-col space-y-0" >
                    <div class=" hover:cursor-pointer">▲</div>
                    <div class=" hover:cursor-pointer">▼</div>
                  </div>
                  <div @click="setOrderByInvoiceDay(null)" v-else-if="orderedByInvoiceDayAscending">
                    <div class=" hover:cursor-pointer">▲</div>
                  </div>
                  <div @click="setOrderByInvoiceDay('asc')" v-else-if="orderedByInvoiceDayDescending">
                    <div class=" hover:cursor-pointer">▼</div>
                  </div>
                </div>
              </div>
            </base-table-header>
            </template>

            <template #table-body>
            <EngagementRow
                :key="engagement.id"
                :engagement="engagement"
                :clients="clients"
                v-for="engagement in orderedEngagements"
                @refetch-engagements="loadEngagements"
                        />
            </template>
        </base-table>
        </div>
    </div>
    </base-card>
</div>
</template>

<script>
export default {
name: 'engagements-table'
}
</script>

<script setup>
import {getEngagements, createEngagement} from '@/services/Engagement.js'
import {useStore} from 'vuex';
import {ref, reactive, shallowReactive, computed, watch} from 'vue';
import EngagementFilters from './EngagementFilters.vue';
import EngagementRow from './EngagementRow.vue';
import BaseCard from "@/components/BaseCard";
import { getAllClientsSimple } from '@/services/Client';
import EngagementForm from './EngagementForm.vue';
import InvoiceDraftModal from '../invoice_components/InvoiceDraftModal.vue';
import { useToast } from 'vue-toast-notification';

const store = useStore()
const isLoading = ref(false);
const $toast = useToast()
const userPermissions = computed(() => store.getters['auth/showUserPermissions'] || {})
const canDoAccounting = computed(() =>
  !!userPermissions.value.isDev
  || !!userPermissions.value.isManagement
  || !!userPermissions.value.isSuperuser
  || !!userPermissions.value.isAccountingGroup
)
const clients = ref([])
const awaitingSearch = ref(false);
const totalRetainers = ref(0)
const formVisible = ref(false)
const draftInvoiceVisible = ref(false)
function onInvoiceSaved() {
  loadEngagements(fetchFilter.value)
}
const showAllItems = reactive({
value: false,
changeCount: 0
})
const tableHeadersList = ref([
{value: 'ID'},
{value: 'Client', orderFieldName: 'client__client_name'},
{value: 'Start Date', orderFieldName: 'start_date'},
{value: 'End Date', orderFieldName: 'end_date'},
{value: 'Retainer Amount'},
{value: 'Billing Timeframe'},
{value: 'Invoice Due Delta'},
{value: 'Next Calc. Invoice Day'},
{value: 'Days Until Next Calc. Invoice Day'},
{value: 'Target Due Date'},
{value: 'Last Invoice Nbr: Date (Due)'},
// {value: 'Missing Invoice'},
{value: 'Overdue Count'},
{value: 'Accounting Posts'},
])
const orderBy = ref([])
function setShowAllItems(showOrHide) {
showAllItems.value = showOrHide
showAllItems.changeCount++
}

const engagementFilters = reactive({
client: null,
status: "active",
shouldInvoice: true,
tailStatus: null,
retainerOn: true
});

const pageSizeFilter = reactive({
pageSizeFilter: 50
})

function noOrdering(fieldName) {
  if(!orderBy.value.includes(fieldName) && !orderBy.value.includes('-' + fieldName)){
    return true
  } else {
    return false
  }
}

function orderedDescending(fieldName){
  if(orderBy.value.includes('-' + fieldName)){
    return true
  } else {
    return false
  }  
}

const orderByInvoiceDay = ref('asc')

const orderedEngagements = computed(() => {
  const pausedToBottom = (a, b) => {
    if (a.is_paused && !b.is_paused) return 1
    if (!a.is_paused && b.is_paused) return -1
    return 0
  }
  if(orderByInvoiceDay.value == 'asc'){
    return engagements.value.toSorted((a, b) => {
      const p = pausedToBottom(a, b); if (p !== 0) return p
      return a.days_until_target_invoice_day - b.days_until_target_invoice_day
    })
  } else if (orderByInvoiceDay.value == 'desc'){
    return engagements.value.toSorted((a, b) => {
      const p = pausedToBottom(a, b); if (p !== 0) return p
      return b.days_until_target_invoice_day - a.days_until_target_invoice_day
    })
  }
  return engagements.value.toSorted(pausedToBottom)
})

function orderedAscending(fieldName){
  if(orderBy.value.includes(fieldName)){
    return true
  } else {
    return false
  }  
}

const orderedByInvoiceDayAscending = computed(() => {
  return orderByInvoiceDay.value == 'asc'
})

const orderedByInvoiceDayDescending = computed(() => {
  return orderByInvoiceDay.value == 'desc'
})

function changeOrdering(fieldName) {
  if(orderedAscending(fieldName)){
    const index = orderBy.value.indexOf(fieldName)
    orderBy.value.splice(index, 1)
  } else if(orderedDescending(fieldName)) {
    const index = orderBy.value.indexOf('-' + fieldName)
    orderBy.value[index] = fieldName
  } else {
    orderBy.value.push('-' + fieldName)
  }
}

function orderFieldLabel(orderField) {
  if(orderField == "client__client_name"){
    return "Client Name"
  } else if(orderField == "-client__client_name"){
    return "Client Name (Desc)"
  } else if(orderField == "-start_date"){
    return "Start Date (Desc)"
  } else if(orderField == "start_date"){
    return "Start Date"
  } else if(orderField == "-end_date"){
    return "End Date (Desc)"
  } else if(orderField == "end_date"){
    return "End Date"
  } else if(orderField == "asc"){
    return "Days Until Next Invoice Day"
  } else if(orderField == "desc"){
    return "Days Until Next Invoice Day (Desc)"
  }
  return orderField
}

const engagements = ref([])
const next = ref(null);
const prev = ref(null);
const count = ref(null);
const page = ref(1);
const pageSize = ref(null);
const totalPaid = ref(0)
const totalUnpaid = ref(0)
const totalPages = ref(0)

const fetchFilter = computed(function () {
  let query = new URLSearchParams({
  });
  if (engagementFilters.client) {
      engagementFilters.client.forEach(client => {
        query.append("client", client)
      })
  }
  if (engagementFilters.status) {
      query.append("status", engagementFilters.status)
  }
  if (engagementFilters.shouldInvoice) {
      query.append("should_invoice", engagementFilters.shouldInvoice)
  }
  if (engagementFilters.retainerOn) {
      query.append("retainer_on", engagementFilters.retainerOn)
  }
  if (engagementFilters.tailStatus) {
      query.append("tail_status", engagementFilters.tailStatus)
  }
  if (pageSizeFilter.pageSizeFilter) {
    query.append("page_size", pageSizeFilter.pageSizeFilter); // To append more data
  }
  if(orderBy.value.length > 0){
      query.append("order_by", orderBy.value.join(','))
    }
  let url;
  let queriesCount = 0;
  for (let value of query.values()) {
    queriesCount = queriesCount + 1;
  }
  if (queriesCount > 0) {
    url = "?" + query.toString();
  } else {
    url = "?";
  }
  // console.log(url);
  return url
})

async function loadEngagements(queryParams = fetchFilter.value) {
isLoading.value = true;
const token = store.state.auth.token 
const result = await getEngagements(token, queryParams);
  engagements.value = result.results;
  next.value = result.next ? `&page=${result.page + 1}` : null
  prev.value = result.prev ? `&page=${result.page - 1}` : null
  count.value = result.count
  page.value = result.page
  pageSize.value = result.results.length
  totalRetainers.value = result.total_retainer_amount
  totalPages.value = result.num_pages
  isLoading.value = false;

}

const retainerAmount = computed(() => {

  const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    return formatter.format(totalRetainers.value);
})

function setPageSizeFilter(target=null){
if(target) {
  target == "clear" ? (pageSizeFilter.pageSizeFilter = 50) : (pageSizeFilter.pageSizeFilter = target);
  loadEngagements(fetchFilter.value)
}
}

function setEngagementFilters(updatedFilters) {
// engagementFilters.client = updatedFilters.client;
// engagementFilters.status = updatedFilters.status;
    for(const filter in updatedFilters){
        engagementFilters[filter] = updatedFilters[filter].value
    }
}

function getNext() {
if (next.value) {
  loadEngagements(fetchFilter.value + next.value)
} else {
  alert("No next page")
}
}

function getPrev() {
if (prev.value) {
  loadEngagements(fetchFilter.value + prev.value)
} else {
  alert("No prev page")
}
}

function jumpToPage(targetPage) {
loadEngagements(fetchFilter.value + `&page=${targetPage}`)
}

const viewingFromNbr = computed(function () {
  return (page.value * pageSizeFilter.pageSizeFilter + 1) - pageSizeFilter.pageSizeFilter
})


const viewingToNbr = computed(function () {
if (page.value === totalPages.value) {
  return count.value;
} else {
  return page.value * pageSize.value
}
})

function setOrderByInvoiceDay(target) {
  orderByInvoiceDay.value = target
  if(target){
    orderBy.value = []
  }
}

function goToFirst(){
loadEngagements(fetchFilter.value + `&page=${1}`)
}

function goToLast(){
loadEngagements(fetchFilter.value + `&page=${totalPages.value}`)
}

watch(() => engagementFilters, () => {
if(!awaitingSearch.value) {
      setTimeout(() => {
        loadEngagements(fetchFilter.value);
        awaitingSearch.value = false;
      }, 2000); // 2.5 sec delay
    }
    awaitingSearch.value = true
}, {deep: true})


watch(() => orderBy, () => {
    if(!awaitingSearch.value) {
          setTimeout(() => {
            loadEngagements(fetchFilter.value);
            awaitingSearch.value = false;
          }, 1000); // 1 sec delay
        }
        awaitingSearch.value = true
}, {deep: true})

async function loadClients() {
    const result = await getAllClientsSimple({ token: store.state.auth.token });
    clients.value = result.data;
    // console.log(clientsList.value)
}

function openCreateForm(){
  formVisible.value = true
}

function closeCreateForm(){
  formVisible.value = false
}

async function createNewEngagement(formData){
  const token = store.state.auth.token
  let data = JSON.stringify(formData)
  const result = await createEngagement(data, token)
  if(result.status === 201){
    $toast.open({
      message: 'Successfully created new Engagement',
      type: 'success',
      duration: 3000
    })
    formVisible.value = false
    loadEngagements()
  } else {
    $toast.open({
      message: 'Error, could not create new Engagement',
      type: 'error',
      duration: 3000
    })
  }
}

function clearOrdering(index){
  orderBy.value.splice(index, 1)
}

function clearOrderingByInvoiceDay(){
  orderByInvoiceDay.value = null
}

loadEngagements()
loadClients()

</script>